// WH1 (owner 2026-11-03: "all webhook received data per campaign, where we see and download"): the Webhooks tab of a
// campaign. One row per webhook a vendor sent us that matched this campaign: when, its kind, the vendor's own word, what
// the portal did with it, the person's lead code and our number. Never a mobile, a name or the body (a reply's words).
// 50 a page by a cursor; Download CSV streams every line of the campaign (the filters apply). Kept N days (Settings).
import { z } from 'zod'
import { Id, IsoDateTime } from './common'

export const WebhookKind = z.enum(['wa-status', 'wa-reply', 'digits', 'call-status', 'sms-status'])
export type WebhookKind = z.infer<typeof WebhookKind>

export const CampaignWebhookRow = z.object({
  id: Id,
  at: IsoDateTime,
  kind: WebhookKind,
  vendor_word: z.string().describe("the vendor's own word, e.g. EX_MESSAGE_DELIVERED, completed, key 1 (empty for a reply)"),
  result: z.string().describe('what the portal did with it, e.g. message delivered, digit recorded, no change'),
  lead_code: z.string(),
  number: z.string().describe("our number's name and display, or empty"),
})
export type CampaignWebhookRow = z.infer<typeof CampaignWebhookRow>

export const CampaignWebhooksQuery = z.object({
  kind: WebhookKind.optional(),
  word: z.string().optional().describe("only lines with this vendor's word"),
  lead_code: z.string().optional().describe('a lead code, or its start'),
  before: z.string().optional().describe('the cursor of the last row shown (CampaignWebhooksPage.next)'),
})
export type CampaignWebhooksQuery = z.infer<typeof CampaignWebhooksQuery>

export const CampaignWebhooksPage = z.object({
  rows: z.array(CampaignWebhookRow),
  next: z.string().nullable().describe('the cursor for the older rows; null = no more'),
  words: z.array(z.string()).describe("the vendor's words in this campaign's latest 5,000 lines (for the filter)"),
})
export type CampaignWebhooksPage = z.infer<typeof CampaignWebhooksPage>

/** The columns of Download CSV, in order. */
export const WEBHOOK_CSV_COLUMNS = ['at', 'kind', 'vendor_word', 'result', 'lead_code', 'number'] as const
